import { ServiceDataFields } from './service-data-fields.enum';

export const negSingleCarrierFieldSet = [
  ServiceDataFields.AdditionalPatientInformation,
  ServiceDataFields.PatientGender,
  ServiceDataFields.DocumentNumber,
  ServiceDataFields.Ethnicity,
  ServiceDataFields.PatientHistoryInformation,
  ServiceDataFields.BoneMarrowTransplant,
];
